import { Injectable, inject } from '@angular/core';
import { ChatMessage, ContextType } from '../models/agent.models';
import { DynamicFlowService } from './dynamic-flow.service';
import { EvaluationService } from './evaluation.service';
import { MessagesStateService } from './messages-state.service';
import { USER_DATA_EXCHANGE, UserDataExchangeAbstractService } from '../models/user-data-exchange';

export type EvaluationJson = {
  text: string;
  score: number;
};

@Injectable({
  providedIn: 'root',
})
export class DynamicFlowTaskService {
  private dynamicFlowService = inject(DynamicFlowService);
  private evaluationService = inject(EvaluationService);
  private messagesStateService = inject(MessagesStateService);
  private userDataExchange = inject<UserDataExchangeAbstractService>(USER_DATA_EXCHANGE);

  public async evaluateAssistantTaskTrigger(message: ChatMessage) {
    const userChatSettings = this.userDataExchange.getUserChatSettings();
    if (!userChatSettings.assistantMessageTask) {
      return;
    }

    const conversationFlow = this.dynamicFlowService.conversationFlowState();
    if (!conversationFlow) return;

    const dynamicFlowTask = conversationFlow.triggerTasks.onAssistantMessage;
    console.log('Trigger:', dynamicFlowTask);
    if (dynamicFlowTask && message.messageId) {
      const messageId = message.messageId;
      // const contextMessages = this.contextEngineService.getContextMessages(this.messagesStateService.getMessagesSignal()(), ContextType.LastAssistantMessage);
      // i cant override task in trigger.
      const task = dynamicFlowTask.task + ' Here is the text: ' + (message.text || message.content);

      const result: EvaluationJson = await this.evaluationService.evaluateWithTask({ model: dynamicFlowTask.model, task });
      console.log('Assistant trigger evaluation result:', result);
      message.evaluation = result;
      this.messagesStateService.updateMessage(messageId, message);
    }
  }

  public async evaluateUserTaskTrigger(message: ChatMessage) {
    const conversationFlow = this.dynamicFlowService.conversationFlowState();
    if (!conversationFlow) return;

    const goal = conversationFlow.goal;
    // 1) Run Goal Evaluation
    // TODO probably i need a different method for the goal.
    this.evaluationService.evaluateGoal(goal);
    // 2) Run User Trigger Evaluation only if user allows it
    const chatUserSettings = this.userDataExchange.getUserChatSettings();
    if (chatUserSettings.userMessageTask) {
      const userTriggerTask = conversationFlow.triggerTasks.onUserMessage;

      // TODO: Siento MUY Forzado el utilizar evaluateConversation, ese es del goal, pero lo quize hacer general!

      if (userTriggerTask && message.messageId) {
        const messageId = message.messageId;
        userTriggerTask.task =
          'Evaluate User Conversation and give feedback in user native language,  fix grammar remark improvements. do explanation in less than 25 words.';
        const evaluation = await this.evaluationService.evaluateConversation(userTriggerTask, ContextType.Last2Messages);
        message.evaluation = evaluation;
        this.messagesStateService.updateMessage(messageId, message);
        console.log('Trigger evaluation result:', evaluation);
      }
    }
  }
}
